import { render, staticRenderFns } from "./PropertyInfo.vue?vue&type=template&id=e5da5f6c&scoped=true&"
import script from "./PropertyInfo.vue?vue&type=script&lang=js&"
export * from "./PropertyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PropertyInfo.vue?vue&type=style&index=0&id=e5da5f6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5da5f6c",
  null
  
)

export default component.exports